export default "__VITE_PUBLIC_ASSET__1e248a50__"